import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { transformUnit, VAT } from "./useFetchUnits";
import { PropertyType } from "src/types";
import { Unit } from "./useFetchUnits";
const isDemo = process.env.NEXT_PUBLIC_DEMO_MODE === "true";

// Define the structure of the data you're expecting from the API
interface CompanyListingDetailsResponse {
  listing: Unit; // Replace `any` with the appropriate type for the listing
  total_available_unit: number;
  total_bookmarks: number;
  total_unit: number;
  total_views: number;
  rent_vat: VAT[];
}
// Fetch function with correct typing
export const fetchCompanyListingDetails = async (
  id: number
): Promise<CompanyListingDetailsResponse> => {
  if (isDemo) {
    return {} as CompanyListingDetailsResponse;
  }
  if (!id) {
    return {} as unknown as CompanyListingDetailsResponse;
  }
  try {
    const { data } = await axios.get<CompanyListingDetailsResponse>(
      `${process.env.NEXT_PUBLIC_BASE_URL}api/v1/custom/company-listing-details/${id}`
    );
    const updated: CompanyListingDetailsResponse = {
      ...data, // original object
      listing: {
        ...data.listing,
        total_available_unit: data.total_available_unit, // new value
        total_bookmarks: data.total_bookmarks,
        total_unit: data.total_unit, // another new value
        total_views: data.total_views,
      },
    };
    return updated; // API response
  } catch (error) {
    console.error("Error fetching company listing details:", error); // Debug log for error
    throw error;
  }
};

// Custom hook to fetch company listing details
const useCompanyListingDetails = (id: number) => {
  console.log({ id });
  return useQuery<PropertyType, Error>({
    queryKey: ["companyListingDetails", Number(id)], // query key to uniquely identify the query
    queryFn: async (): Promise<PropertyType> => {
      const data = await fetchCompanyListingDetails(id); // Ensure correct type from API response

      const transformedData = transformUnit(data.listing); // Apply transformUnit to data.listing
      console.log("transformed", { transformedData });
      return transformedData; // Return transformed data as PropertyType
    },
    enabled: !!id, // Only enable query if ID is available
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    retry: 2, // Retry once on failure
  });
};

export default useCompanyListingDetails;
